<template>
  <Dialog
    :title="$t('suscription.title')"
    :visible.sync="subDialogOpen"
    width="50%"
    custom-class="min-width-dialog"
    center>
    <span class="w-full inline-block dark:text-darkblue-200 word-break-n" v-safe-html="$t('suscription.info')"/>
    <template slot="footer" >
      <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2">
        <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('suscription.resend')" @click="activePortalHandler(true)" :loading="isGeneralLoading" :disabled="isGeneralLoading"/>
        <base-button class="w-full" mode="primary" :text="$t('suscription.ok')" @click="toggleSubDialog()" :loading="isGeneralLoading" :disabled="isGeneralLoading"/>
      </div>
    </template>
  </Dialog>
</template>

<script>
import { i18n } from '@/i18n'
import { bus } from '@/main'
import { activarportalzoho } from '@/services/config/activarportalzoho'
import { Dialog } from 'element-ui'

export default {
  name: 'portal-zoho-dialog',
  components: {
    Dialog,
  },
  data: function () {
    return {
      subDialogOpen: false,
      urlPortalZoho: 'https://suscripciones.zerocoma.com/portal/zerocoma/signin',
    }
  },
  created () {
    bus.$on('activePortalZoho', this.activePortalHandler)
  },
  beforeDestroy () {
    bus.$off('activePortalZoho', this.activePortalHandler)
  },
  computed: {
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    isLower1024: function () {
      return this.$store.getters['app/getIsLower1024']
    },
  },
  methods: {
    toggleSubDialog () {
      this.subDialogOpen = !this.subDialogOpen
    },
    activePortalHandler: async function (retry = false) {
      this.$store.commit('setIsLoading', true)
      try {
        this.doFeedback(i18n.t('suscription.waiting'), 'info')
        const response = await activarportalzoho()
        if (response.blnError) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          if (response.Respuesta) {
            this.subDialogOpen = false
            window.open(this.urlPortalZoho, '_blank')
          } else {
            this.subDialogOpen = true
            if (retry) {
              this.doFeedback(i18n.t('suscription.resent'), 'success')
            }
          }
        }
      } catch (error) {
        console.log('error', error)
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
  },
}
</script>

<style scoped>
</style>
